<template>
    <div class="calls">
        <card type="cinc" class="ReClientCall lightTheme"> <!--v-if="objCall.call_record !=''"-->
            <div slot="header">
                <div class="row align-items-center">
                    <div class="col">                
                        <span class="badge badge-pill badge-primary">Звонок из Reactor</span>
                        
                        <div class="date"><span>{{$GVO.convertDateTimeFromMysql(objCall.InsTime)}}</span></div>

                        <div class="note-content" v-if="objCall.agent_name != null"><p class="description">Кто звонил: {{objCall.agent_name}}</p></div>
                        <div class="note-content" v-if="objCall.call_start != null && objCall.call_start != ''">
                            <p class="text-success">{{strPhone}}</p>
                            <p class="text-success">{{callRecipient}} ответил</p>
                            <!-- <p class="text-success">Клиент ответил</p> -->
                        </div>  
                        <div class="note-content" v-if="objCall.call_start == null || objCall.call_start == ''"><p class="text-danger">{{callRecipient}} не взял трубку</p></div>  
                        <div class="note-content" v-if="objCall.duration == 0 "><p>Время ожидания: {{objCall.waiting_time}} сек.</p></div>  

                        <ReAudioComponent
                                v-if="(objCall.call_start != null && objCall.call_start != '') || objCall.filesize == false"
                                :record="'/DATA/PhoneRec/' + objCall.call_record"
                                @reload="reloadAudio()"
                                @update-record="handleUpdateRecord(objCall, $event)"
                            />
                        <div v-if="objCall.summary">{{ objCall.summary }}</div>
                    </div>

                </div>
            </div> 
            <!--pre>{{objCall}}</pre-->
        </card>
    </div>
</template>

<script>
import ReAudioComponent from '../ReAudioComponent.vue';



export default {
    name: 'ReClientCall',
    components: {
        ReAudioComponent,
    },
    props: {
        counter: String,
        findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
            type: String,
            default: '',            
        },
        objCall: {
            type: Object,
            default: function() {
				return {};
			}
        },
        // callRecipient: {
        //     type: String,
        //     default: 'Абонент',  
        // },
        recipientPhone: [String,Number],	


    },
    data () {
        return {
            ver: 1,            
            strAudioLink: `/DATA/PhoneRec/${this.objCall.call_record}.mp3?r=`+Math.random(),
        }
    },
    computed: {
        strPhone(){
            let obj = this.$GVO.SafeParseJson(this.objCall.jdata)
            if(typeof obj.phone != 'undefined' && obj.phone != this.recipientPhone && (this.objCall.obj_type=='LEAD')){
                
                return 'Телефон агента: ' + obj.phone;
            } else if (typeof obj.phone != 'undefined' && obj.phone == this.recipientPhone){
                return 'Телефон клиента: ' + obj.phone;
            }
            return '';
        },
        callRecipient: function(){
            let obj = this.$GVO.SafeParseJson(this.objCall.jdata);
            // console.log('obj.phone', obj.phone);
            
            if(typeof obj.phone != 'undefined' && obj.phone != this.recipientPhone){
                if(this.objCall.obj_type=='LEAD')
                    return 'Агент';
            }
            return 'Клиент';
        }

    },
    methods: {     
        async reloadAudio(){
            let res = await this.$GVO.Api.PhoneCallApi.calls_check_file({flt:{id:this.objCall.id}});
            if(res.success == true){
                this.handleUpdateRecord(this.objCall, res.data.file_name);
            }
            // alert('Перезагружаем разговор '+this.objCall.id);

        },
		handleUpdateRecord(row, newRecord) {
			// Обновляем RecID в объекте строки
			row.call_record = newRecord.replace('/DATA/PhoneRec/','');
		},        
    },
}
</script>
<style scoped>
.ReClientCall {border: 1px solid rgba(1, 176, 224, 0.4)}
.ReClientCall .date {
    font-size: 12px;
    color: #9A9A9A;
    margin: 5px 0px;
}
.ReClientCall >>> .card-body {padding: 0px 15px 15px 15px;}
.badge-grey {background: #9A9A9A; color: #fff;}
.ReClientCall >>> audio {
    outline: none;
	border-radius: 2rem;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.ReClientCall >>> figure {margin-bottom: 0px;}
.ReClientCall .description{font-size: 14px; color:#9A9A9A;}
.call-audio {
    background-color: transparent;
    border: 1px solid #01B0E0;
    box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.white-content .card:not(.card-white) .lightTheme {border: 1px solid #c4c4c4;}

figure > *{display: inline-block;}
figure > a.a-dwld, figure > a.a-refresh{
    font-size: 35px;
    vertical-align: top;
    margin-top: 10px;
    margin-left: 20px;
    cursor: pointer;
}
a.a-refresh{color: #9e77f3;}
a.a-refresh:hover{color: #01B0E0;}

@media (max-width: 400px) {
    audio {width: 215px;}
}
@media (max-width: 853px) and (min-width: 768px) {
    audio {width: 230px;}
}

</style>
